// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"NonDisclosureToolTipWarning_buttonWrapper__WBv0E","divider":"NonDisclosureToolTipWarning_divider__+Z5C1"};